'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var makeApiCallAction = exports.makeApiCallAction = function makeApiCallAction(ACTION_NAME, asyncAction) {
  for (var _len = arguments.length, payload = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    payload[_key - 2] = arguments[_key];
  }

  return function (dispatch) {
    dispatch({
      type: ACTION_NAME + '_START'
    });

    if (typeof asyncAction.then === 'function') {
      return asyncAction.then(function (response) {
        dispatch({
          type: ACTION_NAME + '_COMPLETE',
          payload: response.data,
          response: response
        });

        return response;
      }).catch(function (err) {
        if (err.isNetworkException) {
          return dispatch({
            type: ACTION_NAME + '_FAILURE',
            payload: err
          });
        }

        throw err;
      });
    }

    return asyncAction.apply(undefined, payload).then(function (response) {
      dispatch({
        type: ACTION_NAME + '_COMPLETE',
        payload: response.data,
        response: response,
        requestData: payload
      });

      return response;
    }).catch(function (err) {
      if (err.isNetworkException) {
        return dispatch({
          type: ACTION_NAME + '_FAILURE',
          payload: err,
          requestData: payload
        });
      }

      throw err;
    });
  };
};